import { render, staticRenderFns } from "./newEditAvisos.vue?vue&type=template&id=5cbb8ffe"
import script from "./newEditAvisos.vue?vue&type=script&lang=js"
export * from "./newEditAvisos.vue?vue&type=script&lang=js"
import style0 from "./newEditAvisos.vue?vue&type=style&index=0&id=5cbb8ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports